import script from "./onboarding-form.vue?vue&type=script&setup=true&lang=js"
export * from "./onboarding-form.vue?vue&type=script&setup=true&lang=js"

import "./onboarding-form.vue?vue&type=style&index=0&id=fd75a84a&lang=scss"

const __exports__ = script;

export default __exports__